import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { OperationsUrlSettings } from '../amministrazione/configuration/operations-url-settings';
import { NomiDescrittoriSezione } from '../common/configuration/nomi-descrittori-sezione';
import { DescrittoreSezione } from '../common/models/descrittore-sezione';
import { UrlSettingsCore } from '../core/configuration/url-settings-core';
import { HelpersService } from '../core/services/helpers.service';
import { ModalNotifyService } from '../core/services/modal-notify.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardAmministrazioneService implements CanActivate, CanActivateChild {

  descrittori: DescrittoreSezione[] = [];
  constructor(private helpersService: HelpersService, private router: Router, private modalNotifyService: ModalNotifyService){
  }

  //USATO PER CONTROLLARE LA ROTTA PADRE
  canActivate(
    next: ActivatedRouteSnapshot): Observable<boolean> | boolean {
      let subject = new Subject<boolean>();
      if(this.descrittori.length === 0){
        this.helpersService.getDescrittori().subscribe(res => {
          this.descrittori = res;
          return subject.next(this.checkDescrittori(res, next))
        })
      }else return this.checkDescrittori(this.descrittori, next);

      return subject.asObservable();
  }

  //USATO PER CONTROLLARE LE ROTTE FIGLIE
  canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    let subject = new Subject<boolean>();
    if(this.descrittori.length === 0){
      this.helpersService.getDescrittori().subscribe(res => {
        this.descrittori = res;
        return subject.next(this.checkDescrittori(res, childRoute))
      })
    }else return this.checkDescrittori(this.descrittori, childRoute);

    return subject.asObservable();
  }

  checkDescrittori(descrittori: DescrittoreSezione[], route: ActivatedRouteSnapshot): boolean{
    let checkDescrittore: boolean = false;
    let descriptors = [
      NomiDescrittoriSezione.DESCRITTORE_GESTIONE_TIPOLOGICHE,
      NomiDescrittoriSezione.DESCRITTORE_GESTIONE_UTENTI,
      NomiDescrittoriSezione.DESCRITTORE_GESTIONE_PROFILI,
      NomiDescrittoriSezione.DESCRITTORE_GESTIONE_FORMULARIO,
      NomiDescrittoriSezione.DESCRITTORE_GESTIONE_TABELLE,
      NomiDescrittoriSezione.DESCRITTORE_GESTIONE_ANAGRAFICHE,
      NomiDescrittoriSezione.DESCRITTORE_GESTIONE_METADATI,
      NomiDescrittoriSezione.DESCRITTORE_CRUSCOTTO_CONSERVAZIONE,
      NomiDescrittoriSezione.DESCRITTORE_CRUSCOTTO_NOTIFICHE
    ]
    // controllo che almeno uno dei descrittori elencati contenga writable = true
    if(route.data && route.data.descrittore){
      // debugger
      // let descrittore =  route.data.descrittore;
      let descrittoreUser = descrittori.find(el => descriptors.indexOf(el.entitySimpleName) > -1 && el.writable );
      if(descrittoreUser && (descrittoreUser.readable || descrittoreUser.writable)){
        checkDescrittore = true;
      }else{
        this.allertMessage(false);
        return checkDescrittore = false;
      }
    }else checkDescrittore = true;

    //controllo se hanno il typeGestione allora va controllato il dewcrittore relativo al typeGestione
    if(route.params['typeGestione']){
      let desTypeGestione;
      switch(route.params['typeGestione']) {
        case OperationsUrlSettings.nomeUtenti || OperationsUrlSettings.nomeGruppi: {
          desTypeGestione = descrittori.find(el => el.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_GESTIONE_UTENTI);
          if(desTypeGestione && (desTypeGestione.readable || desTypeGestione.writable)) checkDescrittore = true;
          else {
            this.allertMessage(false);
            return checkDescrittore = false;
          }
          break;
        }
        case OperationsUrlSettings.nomeProfili: {
          desTypeGestione = descrittori.find(el => el.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_GESTIONE_PROFILI);
          if(desTypeGestione && (desTypeGestione.readable || desTypeGestione.writable)) checkDescrittore = true;
          else {
            this.allertMessage(false);
            return checkDescrittore = false;
          }
          break;
        }
        case OperationsUrlSettings.nomeAnagrafiche: {
          desTypeGestione = descrittori.find(el => el.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_GESTIONE_ANAGRAFICHE);
          if(desTypeGestione && (desTypeGestione.readable || desTypeGestione.writable)) checkDescrittore = true;
          else {
            this.allertMessage(false);
            return checkDescrittore = false;
          }
          break;
        }
        case OperationsUrlSettings.nomeTabelle: {
          desTypeGestione = descrittori.find(el => el.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_GESTIONE_TABELLE);
          if(desTypeGestione && (desTypeGestione.readable || desTypeGestione.writable)) checkDescrittore = true;
          else {
            this.allertMessage(false);
            return checkDescrittore = false;
          }
          break;
        }
        case OperationsUrlSettings.nomeFormulario: {
          desTypeGestione = descrittori.find(el => el.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_GESTIONE_FORMULARIO);
          if (desTypeGestione && (desTypeGestione.readable || desTypeGestione.writable)) checkDescrittore = true;
          else {
            this.allertMessage(false);
            return checkDescrittore = false;
          }
          break;
        }
        case OperationsUrlSettings.nomeMetadati: {
          desTypeGestione = descrittori.find(el => el.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_GESTIONE_METADATI);
          if (desTypeGestione && (desTypeGestione.readable || desTypeGestione.writable)) checkDescrittore = true;
          else {
            this.allertMessage(false);
            return checkDescrittore = false;
          }
          break;
        }
      }
    }

    return checkDescrittore
  }

  allertMessage(permesso: boolean){
    if(!permesso){
      this.modalNotifyService.messaggioCustom('Permesso negato', 'Attenzione!');
      this.router.navigate([UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD]);
    }
  }
}


